export enum CrewEntryDescentType {
  ENTRY = 0,
  DESCENT = 1,
}
